module.exports = __webpack_public_path__ + "static/media/materials.13755d1c.svg";